<template lang="pug">
  nt-dialog(
    :value="value" 
    :width="600"
    :title="title"
    scrollable 
    @input="$emit('input')"
  ) 
    v-card-text
      slot
    v-card-actions
      v-row(no-gutters)
        v-btn( 
          outlined 
          block 
          @click="$emit('addRow')"
        ).mb-3
          v-icon(
            large
            color="orange"
          ) mdi-plus
          | {{ $t('button.add-number-template-group') }} 
        n-btn-submit( 
          :disabled="submitstatus"
          @click="$emit('submit')"
        ) {{ $t('button.save') }} 
</template>
<script>
export default { 
  props : {
    title : {
      type : String,
      default : null
    },
    value : {
      type : Boolean,
      default : false
    },
    submitstatus : {
      type : Boolean,
      default : false 
    }
  },
}
</script>